export interface Step3Data {
  documentoRGCPF: File | null;
  comprovanteFormacao: File | null;
  comprovanteResidencia: File | null;
}

export const validateStep3 = (
  data: Step3Data
): Partial<Record<keyof Step3Data, string>> => {
  const errors: Partial<Record<keyof Step3Data, string>> = {};

  if (!data.documentoRGCPF)
    errors.documentoRGCPF = "Documento RG/CPF é obrigatório";
  if (!data.comprovanteFormacao)
    errors.comprovanteFormacao = "Comprovante de formação é obrigatório";
  if (!data.comprovanteResidencia)
    errors.comprovanteResidencia = "Comprovante de residência é obrigatório";

  return errors;
};
